import type { FC, ReactNode } from 'react';

import FadePageWrapper from '../components/animation/fade-page';

const PageWrapper: FC<{
  children: ReactNode;
  disableFadePage?: boolean;
}> = ({ children, disableFadePage }) => {
  if (disableFadePage) return <>{children}</>;
  return <FadePageWrapper>{children}</FadePageWrapper>;
};

export default PageWrapper;

